import type { MouseEvent } from "react";
import { styled } from "styled-components";

import { ImageBackground, PlayIcon, SourceLabel } from "common/components";
import type { CustomKnowledge } from "domains/customContentAndSources/types";
import { StyledContent, StyledTitle, StyledType } from "domains/knowledgeFeed/components/shared";
import { KnowledgeDetailButton } from "domains/publication/components/KnowledgeDetailButton";
import type { Knowledge } from "entities/knowledge/types";

const StyledRow = styled.div`
  display: flex;
  margin-right: 1rem;
`;

const StyledOuterRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledImageContainer = styled.div`
  position: relative;
  align-self: center;
`;

const StyledImage = styled(ImageBackground)`
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  border-radius: 5px;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSmallPlayIcon = styled(PlayIcon)`
  transition: transform 0.3s;
  width: 42px;
  height: 42px;
  color: white;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 1rem;
  margin: auto;
`;

type VideoCardProps = { knowledge: Knowledge | CustomKnowledge; link: string };

export const VideoCard = ({ knowledge, link }: VideoCardProps) => {
  const { images, title, source, time, knowledgeType } = knowledge;
  const onDetailLinkClick = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <StyledOuterRow>
      <StyledRow>
        <StyledImageContainer>
          <StyledImage src={images?.thumbnail} />
          <StyledSmallPlayIcon />
        </StyledImageContainer>
        <StyledContent>
          <StyledType>{knowledgeType}</StyledType>
          <StyledTitle>{title}</StyledTitle>
          <SourceLabel date={time} hideImage source={source} type="small" />
        </StyledContent>
      </StyledRow>
      <KnowledgeDetailButton link={link} onClick={onDetailLinkClick} title={knowledge.title} />
    </StyledOuterRow>
  );
};
